import {
  collection,
  doc,
  getDocs,
  addDoc,
  updateDoc,
  where,
  orderBy,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../../../firebase';
import { tenantQuery } from '../../../utils/firestoreHelpers';
import { getTrackingInfoByBillIds } from '../../../utils/firebaseService';

// ── Helpers ───────────────────────────────────────────────────────────────────

const normalizePhone = (phone) =>
  typeof phone === 'string'
    ? { countryCode: '+90', number: phone }
    : phone || { countryCode: '+90', number: '' };

const capitalizeWords = (str) => {
  if (!str) return str;
  return str.trim().toLowerCase().split(' ')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
};

// ── Müşteri Sorguları ─────────────────────────────────────────────────────────

export async function fetchActiveCustomers(businessId) {
  const q = tenantQuery(
    collection(db, 'users'),
    businessId,
    where('role', '==', 'customer'),
    where('status', '==', 'active'),
  );
  const snap = await getDocs(q);
  return snap.docs
    .map(d => ({ id: d.id, ...d.data(), phone: normalizePhone(d.data().phone) }))
    .sort((a, b) => a.name.localeCompare(b.name, 'tr'));
}

export async function fetchActiveEmployees(businessId) {
  const q = tenantQuery(
    collection(db, 'users'),
    businessId,
    where('role', '==', 'employee'),
    where('status', '==', 'active'),
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

// ── Müşteri Mutasyonları ──────────────────────────────────────────────────────

export async function addCustomer(data, businessId) {
  return addDoc(collection(db, 'users'), {
    ...data,
    name: capitalizeWords(data.name),
    surname: capitalizeWords(data.surname),
    businessId,
    createdAt: serverTimestamp(),
  });
}

export async function updateCustomer(customerId, data, businessId) {
  return updateDoc(doc(db, 'users', customerId), {
    ...data,
    name: capitalizeWords(data.name),
    surname: capitalizeWords(data.surname),
    businessId,
    updatedAt: serverTimestamp(),
  });
}

export async function softDeleteCustomer(customerId) {
  return updateDoc(doc(db, 'users', customerId), { status: 'deleted' });
}

// ── Adisyon + Tracking ────────────────────────────────────────────────────────

export async function fetchCustomerBillsWithTracking(customerId, businessId) {
  const q = tenantQuery(
    collection(db, 'bills'),
    businessId,
    where('customerId', '==', customerId),
    where('status', '==', 'active'),
    orderBy('date', 'desc'),
  );
  const snap = await getDocs(q);
  const bills = snap.docs.map(d => ({ id: d.id, ...d.data() }));

  // Batch tracking fetch — N+1 sorununu önler (best-effort, izin yoksa boş döner)
  const billIds = bills.map(b => b.id);
  let trackingMap = {};
  try {
    trackingMap = billIds.length > 0 ? await getTrackingInfoByBillIds(billIds, businessId) : {};
  } catch {
    // tracking verisi olmadan adisyonlar yine de gösterilir
  }

  return { bills, trackingMap };
}

// ── Paketler ──────────────────────────────────────────────────────────────────

export async function fetchCustomerPackages(customerId, businessId) {
  const q = tenantQuery(
    collection(db, 'customer_packages'),
    businessId,
    where('customerId', '==', customerId),
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}
